import * as st from './circlePlayButtonPlaceholder.module.scss'
import * as React from 'react'

export const CirclePlayButtonPlaceholder = () => <div className={st.heroPlaybackPlaceholder}/>
